import { gql } from "@apollo/client";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { apolloClient } from "../../..";
import ChevronRight from "../../../icons/ChevronRight/ChevronRight";
import SharedIcon from "../../UI/SharedIcon/SharedIcon";
class ArchiveBreadcrumbs extends Component {
  state = {
    breadcrumbsTitle: "Archives",
    breadCrumbRoot: {},
    breadCrumbParent: {},
  };

  componentDidMount() {
    if (this.props.match.path === "/archives/:folderId") {
      apolloClient
        .query({
          query: gql`
            query Folder($folderId: UUID!) {
              folder(folderId: $folderId) {
                id
                title
              }
            }
          `,
          variables: {
            folderId: this.props.match.params.folderId,
          },
        })
        .then((result) => {
          const folder = result.data.folder[0];
          this.setState({
            breadCrumbRoot: {
              rootId: null,
              rootTitle: null,
              parentId: folder.id,
              parentTitle: folder.title,
            },
          });
        })
        .catch((e) => {});
    } else if (
      this.props.match.path === "/archives/:folderId/:subId" ||
      this.props.match.path === "/archives/:folderId/:subId/:docId"
    ) {
      apolloClient
        .query({
          query: gql`
            query Folder($folderId: UUID!) {
              folder(folderId: $folderId) {
                id
                title
                parentFolder {
                  id
                  title
                }
              }
            }
          `,
          variables: {
            folderId: this.props.match.params.subId,
          },
        })
        .then((result) => {
          const folder = result.data.folder[0];
          this.setState({
            breadCrumbParent: {
              rootId: folder.parentFolder.id,
              rootTitle: folder.parentFolder.title,
              parentId: folder.id,
              parentTitle: folder.title,
            },
          });
        })
        .catch((e) => {});
    }
  }
  render() {
    return (
      <div className="mt-7 mb-8">
        <div className="is-size-h4 d-md-flex">
          <Link to={`/archives`}>{this.state.breadcrumbsTitle}</Link>
          {this.state.breadCrumbRoot.rootTitle ? (
            <>
              <ChevronRight />
              <Link
                to={`/archives/${this.state.breadCrumbRoot.rootId}`}
              >{`${this.state.breadCrumbRoot.rootTitle}`}</Link>
              <SharedIcon
                isFolder={true}
                itemId={this.state.breadCrumbRoot.rootId}
              />
            </>
          ) : this.state.breadCrumbRoot.rootTitle === null ? (
            <>
              <ChevronRight />
              <Link
                to={`/archives/${this.state.breadCrumbRoot.parentId}`}
              >{`${this.state.breadCrumbRoot.parentTitle}`}</Link>
              <SharedIcon
                isFolder={true}
                itemId={this.state.breadCrumbRoot.parentId}
              />
            </>
          ) : this.state.breadCrumbParent.parentTitle ? (
            <>
              <ChevronRight />
              <Link
                to={`/archives/${this.state.breadCrumbParent.rootId}`}
              >{`${this.state.breadCrumbParent.rootTitle}`}</Link>
              <SharedIcon
                isFolder={true}
                itemId={this.state.breadCrumbParent.rootId}
              />
              <ChevronRight />
              <Link
                to={`/archives/${this.state.breadCrumbParent.rootId}/${this.state.breadCrumbParent.parentId}`}
              >{`${this.state.breadCrumbParent.parentTitle}`}</Link>
              <SharedIcon
                isFolder={true}
                itemId={this.state.breadCrumbParent.parentId}
              />
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ArchiveBreadcrumbs;
